module.exports = window.__loadMfRemote("profile", "profileUrl");